import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
// import UploadService from "./components/UploadService";
import HydroFlow from "./components/HydroProcessContainer";
import StepFlow from "./components/COFProcessContainer";
import ProcessConcreteOrSteel from "./components/ProcessConcreteAndSteel";
import Login from "./components/Login";
import Register from "./components/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/Dashboard";
import UserDashboard from "./components/UserDashboard";
import DisplayTableToUser from "./components/DisplayTableToUser";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/home" element={<Home />} />
      {/* <Route
        path="/upload"
        element={
          <ProtectedRoute>
            <UploadService />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/uploadHydro"
        element={
          <ProtectedRoute>
            <HydroFlow />
          </ProtectedRoute>
        }
      />
      <Route
        path="/concreteSteel"
        element={
          <ProtectedRoute>
            <ProcessConcreteOrSteel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/form"
        element={
          <ProtectedRoute>
            <StepFlow />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/register" element={<Register />} />
      <Route
        path="/userDashboard"
        element={
          <ProtectedRoute>
            <UserDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/displayData"
        element={
          <ProtectedRoute>
            <DisplayTableToUser />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;